/** The list page's header: the title, with the page's actions to its right. */
import type { ReactNode } from 'react';

import './ticket-sales-campaigns-list.css';

export function TicketSalesCampaignsListHeader({ actions }: { actions: ReactNode }) {
  return (
    <header className="tsc-list-header">
      <div className="tsc-list-header-row">
        <h1 className="nb-display tsc-list-title">Ticket sales campaigns</h1>
        <div className="tsc-list-actions">{actions}</div>
      </div>
    </header>
  );
}
